import { useState, useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table, message } from "antd";
import { useLockFn } from "ahooks";
import { TradeTypeEnum } from "@/types/FmsEnums";
import { useDetailModel } from "./detailModel";
import { AppDrawer } from "@/components/YhDrawer";
import { billDataModel } from "./bill/billDataModel";
import { InvoiceBill } from "@/views/invoice/manage/InvoiceManageTypes";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export function NoBill() {

    const { nobillVisible, setNobillVisible } = useDetailModel();
    const { selectedData, onSearch } = billDataModel();
    const [dataSource, setDataSource] = useState<InvoiceBill[]>([])

    const columns: ColumnsType<InvoiceBill> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            align: "center",
            width: 100,
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 50,
            ellipsis: true,
            align: "center",
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        }
    ];

    useEffect(() => {
        setDataSource(selectedData);
    }, [nobillVisible])

    const onOk = useLockFn(async () => {
        try {
            let billCodes = selectedData.map(e => e.code);
            let insertRet = await invoiceManageService.invoiceNoTicketIncome(billCodes);
            if (insertRet) {
                message.success("操作成功!");
                onSearch();
                setNobillVisible(false);
            } else {
                message.error("操作失败!");
            }
        } catch (e) {
            console.log("系统错误" + e);
        }
    })

    const onCancel = () => {
        setNobillVisible(false);
    }

    return (
        <AppDrawer
            {...{
                title: "无票收入",
                visible: nobillVisible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true,
                width: 600,
                okText: "保存",
                cancelText: "返回"
            }}
        >
            <Table
                rowKey={record => record.key}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                }}
            />
        </AppDrawer>
    )
}

